
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//AngularFire
import { AngularFireStorage } from '@angular/fire/storage';

import { CategoryService, ToasterService  } from '../../_services';
import { NgxSpinnerService } from "ngx-spinner";

import { Observable } from 'rxjs';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {
  addCategoryForm:FormGroup;
  ref:any;
  downloadURL: Observable<string>;
  pictureFile:any;
  pictureEventTarget:any;
  ref2:any;
  downloadURL2: Observable<string>;
  pictureFile2:any;
  pictureFileName2:string;
  pictureDownloadUrl:string;
  videoDownloadUrl:string;
  constructor(
    public dialogRef: MatDialogRef<AddCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _category : CategoryService,
    private afStorage: AngularFireStorage,
    private spinner: NgxSpinnerService,
    private _toaster: ToasterService
  ) { }

  ngOnInit(): void {
    
    this.addCategoryForm = this.formBuilder.group({
      name: [null, []],
    })
    if(this.data?.id){
      this.addCategoryForm.patchValue({name:this.data.name});
    }
  }

  hideDialog() {
    this.dialogRef.close();
  }

    // Upload Picture
  async  uploadPicture(event){
      this.pictureFile = (event.target as HTMLInputElement).files;
      const randomId = Math.random().toString(36).substring(2);
      this.pictureEventTarget = event.target.files
      // this.ref = this.afStorage.ref(`products/${randomId}-${event.target.files[0].name}`);

    }

  onFormSubmit(){
    this.spinner.show();
    const formData = this.addCategoryForm.value;
    formData.date_created = new Date().getTime();
    formData.date_updated = new Date().getTime();
    if(this.data?.id){
      this._category.editCategory(formData,this.data?.id).then((res:any) => {
        this.spinner.hide();
        this.dialogRef.close();
        this._toaster.showSuccess("Category edite successfully!", "Success");
      }) .catch(err=>{
        this.spinner.hide();
        this.dialogRef.close();
        this._toaster.showError("'Category not edited!", "Error");
      })
    }
    else {
      this._category.addCategory(formData).then((res:any) => {
        this.spinner.hide();
        this.dialogRef.close();
        this._toaster.showSuccess("Category added successfully!", "Success");
      }) .catch(err=>{
        this.spinner.hide();
        this.dialogRef.close();
        this._toaster.showError("'Category not added!", "Error");
      })
    }


  }

}
